/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        },
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

/*  

ACCORDIAN

*/

(function ($) {
  var allPanels = $(".accordion > dd").hide();

  $(".accordion").on("click", ".accordion-control", function (e) {
    e.preventDefault(); //prevent default action of a button
    $(this) //get the element the user clicked on
      .next(".accordion-panel") //select the next accordion panel
      .not(":animated") //if it is not currently animating
      .slideToggle(); //use slideToggle to show or hide it
  });
})(jQuery);

/*  

CAROUSEL

*/

(function ($) {
  $(document).ready(function () {
    $(".slider--inner").slick({
      // autoplay: true,
      dots: true,
      speed: 1000,
      arrows: true,
    });

    // $(".slick-arrow").on("click", function() {
    //   $(".slider--inner").slick("slickPause");
    // });
  });
})(jQuery);

/*  

Detects i Version

*/
(function ($) {
  $(document).ready(function () {
    var touchPoints = navigator.maxTouchPoints;

    if (touchPoints < 5) {
      $(".redeem_button_desk").addClass("iOS_version");
      $(".redeem_button_14").removeClass("iOS_version");
      $(".redeem_button_13").removeClass("iOS_version");
    } else {
      function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
          var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
          return [
            parseInt(v[1], 10),
            parseInt(v[2], 10),
            parseInt(v[3] || 0, 10),
          ];
        }
      }

      ver = iOSversion();

      if (ver) {
        if (ver[0] > 13) {
          $(".redeem_button_14").addClass("iOS_version");
          $(".redeem_button_13").removeClass("iOS_version");
          $(".redeem_button_desk").removeClass("iOS_version");
        } else {
          $(".redeem_button_14").removeClass("iOS_version");
          $(".redeem_button_13").addClass("iOS_version");
          $(".redeem_button_desk").removeClass("iOS_version");
        }
      } else {
        $(".redeem_button_14").addClass("iOS_version");
        $(".ipad_text").addClass("view");
        $(".redeem_button_13").removeClass("iOS_version");
        $(".redeem_button_desk").removeClass("iOS_version");
      }
    }
  });
})(jQuery);

// KnowledgeBase pagination //

(function ($) {
  $(document).ready(function () {
    $(".hkb-site-search__field").attr("placeholder", "Enter keyword");
    $(".ht-voting-comment").css("background-color", "green");
    function replaceArrow() {
      if ($(this).is(':contains("« Previous Page")')) {
        $(this).text("Previous")[0].className = "pagination_previous";
      }
      if ($(this).is(':contains("« 上一页")')) {
        $(this).text("上一页")[0].className = "pagination_previous";
      }
      if ($(this).is(':contains("« 上一頁")')) {
        $(this).text("上一頁")[0].className = "pagination_previous";
      }
      if ($(this).is(':contains("Next Page »")')) {
        $(this).text("Next")[0].className = "pagination_next";
        $(".pagination").css("text-align", "right");
      }
      if ($(this).is(':contains("下一页 »")')) {
        $(this).text("下一页")[0].className = "pagination_next";
        $(".pagination").css("text-align", "right");
      }
      if ($(this).is(':contains("下一頁 »")')) {
        $(this).text("下一頁")[0].className = "pagination_next";
        $(".pagination").css("text-align", "right");
      }
    }
    $(".pagination a").each(replaceArrow);
    $(".hkb-search-pagination a").each(replaceArrow);
  });
})(jQuery);

// KnowledgeBase language fixes //

(function ($) {
  $(document).ready(function () {
    function getQueryStringValue(key) {
      return decodeURIComponent(
        window.location.search.replace(
          new RegExp(
            "^(?:.*[&\\?]" +
              encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
              "(?:\\=([^&]*))?)?.*$",
            "i",
          ),
          "$1",
        ),
      );
    }

    // Would write the value of the QueryString-variable called name to the console
    const lang = getQueryStringValue("lang");

    if (lang === "zh-hans") {
      $(".hkb-site-search__field").attr("placeholder", "输入关键字");
      $(".user_guide").html("用户指南");
      $("#htoc-related-articles").html("相关文章");
      $(".hkb-article-related__title").html("相关文章");
      $(".hkb-feedback__title").html("本文是否对您有帮助?");
      $(".user_guide").attr("href", "/faq?lang=zh-hans");
      // MailerLite
      $("input#mailerlite-1-field-email").attr(
        "placeholder",
        "输入电子邮件地址",
      );
      $(".mailerlite-subscribe-submit").html("订阅");
      $(".mailerlite-form-loader").html("请稍候⋯⋯");
    }

    if (lang === "zh-hant") {
      $(".hkb-site-search__field").attr("placeholder", "輸入關鍵字");
      $(".user_guide").html("用戶指南");
      $("#htoc-related-articles").html("相關文章");
      $(".hkb-article-related__title").html("相關文章");
      $(".hkb-feedback__title").html("本文是否對您有幫助?");
      $(".user_guide").attr("href", "/faq?lang=zh-hant");
      // MailerLite
      $("input#mailerlite-1-field-email").attr(
        "placeholder",
        "輸入電子郵件地址",
      );
      $(".mailerlite-subscribe-submit").html("訂閱");
      $(".mailerlite-form-loader").html("請稍候⋯⋯");
    }

    $(".hkb-breadcrumbs li span").each(function () {
      const label = $(this).html().trim();
      console.log(label);
      if (label === "Home") {
        $(this).html(
          lang === "zh-hant" ? "主頁" : lang === "zh-hans" ? "主页" : "Home",
        );
        return;
      }
      if (label === "Knowledge Base") {
        $(this).html(
          lang === "zh-hant"
            ? "用戶指南"
            : lang === "zh-hans"
              ? "用户指南"
              : "User Guide",
        );
        return;
      }
      if (label.startsWith("Search Results for")) {
        const searchTerm = $(".hkb-breadcrumbs").attr("data-search-query");
        $(this).html(
          lang === "zh-hant"
            ? `「${searchTerm}」的搜尋結果`
            : lang === "zh-hans"
              ? `「${searchTerm}」的搜寻结果`
              : label,
        );
        return;
      }
    });

    function onEnabledClick(e) {
      setTimeout(function () {
        if (lang === "zh-hans") {
          $(".ht-voting-upvote").html("是");
          $(".ht-voting-downvote").html("否");
          $(".ht-voting-comment__submit").html("发送反馈");
        }
        if (lang === "zh-hant") {
          $(".ht-voting-upvote").html("是");
          $(".ht-voting-downvote").html("否");
          $(".ht-voting-comment__submit").html("發送反饋");
        }
      }, 500);
      setTimeout(function () {
        if (lang === "zh-hans") {
          if ($(".ht-voting-comment").html() === "Thanks for your feedback")
            $(".ht-voting-comment").html("谢谢您的回馈");
        }
        if (lang === "zh-hant") {
          if ($(".ht-voting-comment").html() === "Thanks for your feedback")
            $(".ht-voting-comment").html("謝謝您的回饋");
        }
      }, 1000);
    }

    let mutationObserver = new MutationObserver((records) =>
      records.forEach((mutation) => {
        $(".enabled").on("click", onEnabledClick);
        $(".ht-voting-comment__submit").on("click", onEnabledClick);
      }),
    );

    $(".hkb-feedback").each(function () {
      mutationObserver.observe(this, { childList: true, subtree: true });
    });

    $(".enabled").on("click", onEnabledClick);

    const articleCat = document.location.pathname.slice(0, 20);

    const splitUrl = document.location.pathname.split("/");

    if (articleCat === "/faq/" && !lang)
      $(document).prop("title", "User Guide");
    if (articleCat === "/faq/" && lang === "zh-hans")
      $(document).prop("title", "用户指南");
    if (articleCat === "/faq/" && lang === "zh-hant")
      $(document).prop("title", "用戶指南");
    console.log(articleCat);
    if (articleCat === "/article-categories/")
      $(document).prop("title", splitUrl[1] + " " + splitUrl[2]);
  });
})(jQuery);
/*  

Homepage featured in Click to show
*/

(function ($) {
  $(document).ready(function () {
    $(".featured_text_area div").each(function () {
      if (!$(this).hasClass("featured_Apple")) {
        $(this).addClass("hidden");
      }
    });
  });

  $(".featured_logos img").each(function () {
    if (
      $(this).hasClass("home_logo") &&
      $(this).attr("id") === "featured_Apple"
    ) {
      $(this).addClass("hidden");
    }

    if (
      $(this).hasClass("home_logo_white") &&
      $(this).attr("id") === "featured_Apple"
    ) {
      $(this).removeClass("hidden");
    }
  });

  $(".home_logo").on("click", function () {
    const logoClass = $(this).attr("id");
    // if ($(".home_logo_white").attr("id") === logoClass) {
    //   console.log("test");
    // }
    $(".featured_logos img").each(function () {
      $(this).attr("id") === logoClass &&
        $(this).hasClass("home_logo_white") &&
        $(this).removeClass("hidden");
      $(this).attr("id") === logoClass &&
        $(this).hasClass("home_logo") &&
        $(this).addClass("hidden");
      $(this).attr("id") !== logoClass &&
        $(this).hasClass("home_logo") &&
        $(this).removeClass("hidden");
      $(this).attr("id") !== logoClass &&
        $(this).hasClass("home_logo_white") &&
        $(this).addClass("hidden");
    });
    $(".featured_text_area div").each(function () {
      $(this).hasClass(logoClass)
        ? $(this).removeClass("hidden")
        : $(this).addClass("hidden");
    });
  });

  function getQueryStringValue(key) {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i",
        ),
        "$1",
      ),
    );
  }

  const lang = getQueryStringValue("lang");

  if (lang === "zh-hans" || lang === "zh-hant" || lang === "ko") {
    $(".featured-in").css("display", "none");
  }

  if (lang === "zh-hans" || lang === "zh-hant" || lang === "ko") {
    $(".tag-list").hide();
    $(".wp-block-tag-cloud").hide();
  }
})(jQuery);

/*  
Hamburger menu Click to show
*/
(function ($) {
  $(document).ready(function () {
    const menuButton = $(".hamburger-menu-button");
    const menuItems = $(".menu-items");

    function handleOutsideClick(event) {
      // Check if the clicked element is inside the menu or the menu button
      if (
        !menuItems.is(event.target) &&
        !menuButton.is(event.target) &&
        menuItems.has(event.target).length === 0
      ) {
        menuItems.css("display", "none");
        $(document).off("click", handleOutsideClick);
      }
    }

    menuButton.click(function (event) {
      event.stopPropagation();
      if (menuItems.css("display") === "flex") {
        menuItems.css("display", "none");
        $(document).off("click", handleOutsideClick);
      } else {
        menuItems.css("display", "flex");
        $(document).on("click", handleOutsideClick);
      }
    });

    function handleResize() {
      var width = $(window).width();
      if (width >= 768) {
        menuItems.css("display", "flex");
        $(document).off("click", handleOutsideClick);
      } else {
        menuItems.css("display", "none");
      }
    }
    $(window).on("resize", function () {
      handleResize();
    });
    handleResize();
  });
})(jQuery);

//
(function ($) {
  $(document).ready(function () {
    const THRESHHOLD = 50;
    const menuBar = $(".menu-bar");
    function handleStickyMenuBar() {
      var top = $(window).scrollTop();
      if (top > THRESHHOLD) {
        menuBar.addClass("sticky-menu");
      } else {
        menuBar.removeClass("sticky-menu");
      }
    }
    $(window).on("scroll", handleStickyMenuBar);
    handleStickyMenuBar();
  });
})(jQuery);

/**
 * Fix WPML href not including certain search params (hk-kb-search)
 * in language selector.
 */
(function ($) {
  $(document).ready(function () {
    const isSearch = $("body").hasClass("search");
    const elems = $(".wpml-ls-sub-menu .wpml-ls-link");
    elems.each(function () {
      const lang = $(this).find("span[lang]").attr("lang");
      // Remove Korean option in search pages
      if (isSearch && lang === "ko") return $(this).parent().remove();
      // Append lang to link
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("lang", lang);
      const newUrl = new URL(window.location.href);
      newUrl.search = searchParams.toString();
      $(this).attr("href", newUrl.toString());
    });
  });
})(jQuery);

/**
 * Fix for showing thumbnails and forcing secure connection (https)
 * in videos in blog and knowledge base pages
 */
(function ($) {
  $(document).ready(function () {
    const isBlogPost = $("body").hasClass("single-post");
    const isKnowledge = $("body").hasClass("single-ht_kb");
    if (!isBlogPost && !isKnowledge) return;
    const elems = $(".wp-block-video video");
    elems.each(function () {
      const src = $(this).attr("src");
      if (src.startsWith("//localhost")) {
        $(this).attr("src", src + "#t=0.01");
        return;
      }
      const newSrc = new URL(src);
      newSrc.hash = "#t=0.01";
      newSrc.protocol = "https:";
      $(this).attr("src", newSrc.toString());
    });
  });
})(jQuery);

/**
 * Localize live search no result message
 */
(function ($) {
  $(document).ready(function () {
    function getQueryStringValue(key) {
      return decodeURIComponent(
        window.location.search.replace(
          new RegExp(
            "^(?:.*[&\\?]" +
              encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
              "(?:\\=([^&]*))?)?.*$",
            "i",
          ),
          "$1",
        ),
      );
    }
    const lang = getQueryStringValue("lang");

    const mutationObserver = new MutationObserver((records) =>
      records.forEach((mutation) => {
        const elem = $(".hkb-searchresults__noresults span");
        if (elem.html() === "Keep typing for live search results") {
          if (lang === "zh-hans") elem.html("请继续输入以搜寻结果");
          if (lang === "zh-hant") elem.html("請繼續輸入以搜尋結果");
        }
        if (elem.html() === "No Results") {
          if (lang === "zh-hans") elem.html("查无结果");
          if (lang === "zh-hant") elem.html("查無結果");
        }
      }),
    );

    $("#hkb-jquery-live-search").each(function () {
      mutationObserver.observe(this, { childList: true, subtree: true });
    });
  });
})(jQuery);
